import { getUserAgent } from "@/libs/getUserAgent";

const rules = ["WebView", "(iPhone|iPod|iPad)(?!.*Safari/)", "Android.*(wv|.0.0.0)"];

const regex = new RegExp(`(${rules.join("|")})`, "ig");

export const getMobileDetectForGCDN = (userAgent: NavigatorID["userAgent"] = navigator.userAgent) => {
  const mobileDeviceTypes = {
    Android() {
      return userAgent.match(/Android/i);
    },
    BlackBerry() {
      return userAgent.match(/BlackBerry/i);
    },
    iOS() {
      return userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera() {
      return userAgent.match(/Opera Mini/i);
    },
    Windows() {
      return userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i);
    },
    any() {
      return (
        mobileDeviceTypes.Android() ||
        mobileDeviceTypes.BlackBerry() ||
        mobileDeviceTypes.iOS() ||
        mobileDeviceTypes.Opera() ||
        mobileDeviceTypes.Windows()
      );
    },
  };
  const isAndroid = () => mobileDeviceTypes.Android();
  const isWebView = () => Boolean(userAgent?.match(regex));
  const isMobile = () => Boolean(userAgent?.match(/mobile/i)) || mobileDeviceTypes.any();
  const isDesktop = () => Boolean(!isMobile() && !isSSR());
  const isMiniAppUser = (miniAppRegex) => Boolean(userAgent?.match(miniAppRegex));
  const isSSR = () => Boolean(userAgent?.match(/SSR/i));

  return {
    isMobile,
    isDesktop,
    isSSR,
    isMiniAppUser,
    isWebView,
    isAndroid,
  };
};

const useMobileDetect = () => {
  return getMobileDetectForGCDN(getUserAgent());
};

export default useMobileDetect;
